export default __webpack_public_path__ + "apply8_165af7a.png";